import { render, staticRenderFns } from "./InspCat2Input.vue?vue&type=template&id=128bd9d7&"
import script from "./InspCat2Input.vue?vue&type=script&lang=js&"
export * from "./InspCat2Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports